import {getFunctions,httpsCallable} from 'firebase/functions';
const call=async(name,data)=>(await httpsCallable(getFunctions(),name)(data)).data;
export const gestionarEvento=async data=>data.accion==='eliminar'?(await httpsCallable(getFunctions(),'gestionarEvento',{timeout:540000})(data)).data:call('gestionarEvento',data);
export const gestionarInvitaciones=data=>call('gestionarInvitaciones',data);
export async function subirArteEvento(eventoId,file){
 if(!['image/png','image/jpeg','image/webp'].includes(file.type)||file.size>6*1024*1024)throw Error('Selecciona una imagen PNG, JPG o WebP de hasta 6 MB.');
 const base64=await new Promise((resolve,reject)=>{const r=new FileReader();r.onload=()=>resolve(String(r.result).split(',')[1]);r.onerror=()=>reject(Error('No se pudo leer la imagen.'));r.readAsDataURL(file);});
 return call('subirArteEvento',{eventoId,base64,contentType:file.type});
}

export const venderEntradas=async datos=>(await httpsCallable(getFunctions(),'venderEntradas')(datos)).data;
